import { __extends } from "tslib";
import React from "react";
import { Text, TouchableOpacity, View } from "react-native";
import PropTypes from "prop-types";
import styles from "./PnmacSend.styles.js";
var PnmacSend = /** @class */function (_super) {
  __extends(PnmacSend, _super);
  function PnmacSend() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacSend.prototype.render = function () {
    var _this = this;
    if (this.props.text.trim().length > 0) {
      return /*#__PURE__*/React.createElement(TouchableOpacity, {
        style: [styles.container, this.props.containerStyle],
        onPress: function () {
          _this.props.onSend({
            text: _this.props.text.trim()
          }, true);
        },
        accessibilityTraits: "button"
      }, /*#__PURE__*/React.createElement(Text, {
        style: [styles.text, this.props.textStyle],
        testID: "send"
      }, this.props.label));
    }
    return /*#__PURE__*/React.createElement(View, {
      testID: "send"
    });
  };
  return PnmacSend;
}(React.Component);
PnmacSend.defaultProps = {
  text: "",
  onSend: function () {},
  label: "Send",
  containerStyle: {},
  textStyle: {}
};
PnmacSend.propTypes = {
  text: PropTypes.string,
  onSend: PropTypes.func,
  label: PropTypes.string,
  containerStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object]),
  textStyle: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
};
export default PnmacSend;